import React from "react"
import { Plus, StickyNote } from "lucide-react"
import "./NotesHeader.style.scss"

interface NotesHeaderProps {
  onNewNote: () => void
}

const NotesHeader = ({ onNewNote }: NotesHeaderProps) => (
  <header className="notes-header">
    <div className="notes-header__title">
      <div className="notes-header__icon">
        <StickyNote size={20} />
      </div>
      <div className="notes-header__copy">
        <h1>My Notes</h1>
        <p>Review and organize your personal study notes</p>
      </div>
    </div>
    <button type="button" className="notes-header__add" onClick={onNewNote}>
      <Plus size={16} />
      <span className="notes-header__add-full">New Note</span>
      <span className="notes-header__add-short">Add</span>
    </button>
  </header>
)

export default NotesHeader
